import styled from "styled-components";
import { width } from "styled-system";

export const COL = styled.col`
  ${width};
`;

export default COL;
